import { render, staticRenderFns } from "./ContentProjectsBlock.vue?vue&type=template&id=4acd4206&scoped=true"
import script from "./ContentProjectsBlock.vue?vue&type=script&lang=js"
export * from "./ContentProjectsBlock.vue?vue&type=script&lang=js"
import style0 from "./ContentProjectsBlock.vue?vue&type=style&index=0&id=4acd4206&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4acd4206",
  null
  
)

export default component.exports